import React from "react";
import clsx from "clsx";
import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
  LightBulbIcon,
} from "@heroicons/react/20/solid";

/**
 * An inline note inside a settings row. "info" is blue; "tip" is the purple recommendation style; "warning" is amber, for
 * something that's blocking.
 */
export const ConsentNote = ({
  tone = "info",
  children,
}: {
  tone?: "info" | "tip" | "warning";
  children: React.ReactNode;
}) => (
  <div
    role={tone === "warning" ? "alert" : undefined}
    className={clsx(
      "flex w-full items-start gap-[10px] rounded-lg border border-solid px-[12px] py-[10px] text-[14px] leading-[20px]",
      tone === "info" && "border-blue-200 bg-blue-50 text-blue-800",
      tone === "tip" && "border-primary-200 bg-primary-50 text-primary-800",
      tone === "warning" && "border-amber-200 bg-amber-50 text-amber-800",
    )}
  >
    {tone === "info" && (
      <InformationCircleIcon className="mt-[1px] h-[18px] w-[18px] shrink-0 text-blue-600" />
    )}
    {tone === "tip" && (
      <LightBulbIcon className="mt-[1px] h-[18px] w-[18px] shrink-0 text-primary-600" />
    )}
    {tone === "warning" && (
      <ExclamationTriangleIcon className="mt-[1px] h-[18px] w-[18px] shrink-0 text-amber-600" />
    )}
    <div className="min-w-0 [&_a]:font-medium [&_a]:text-current [&_a]:underline">{children}</div>
  </div>
);
